import { createContext } from 'react';
import { RefreshTokenActionContextReturnValue } from 'src/hooks';

export const RefreshTokenActionContext =
  createContext<RefreshTokenActionContextReturnValue>(
    {} as RefreshTokenActionContextReturnValue
  );

export const RefreshTokenActionProvider = RefreshTokenActionContext.Provider;
